export default __webpack_public_path__ + "static/media/code-contribution.2d6c8a29.png";